import { Button } from "@mui/material";
import { forwardRef, InputHTMLAttributes } from "react"


export type Props = {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  id: InputHTMLAttributes<HTMLInputElement>["id"];
}

const ImageInput = forwardRef<HTMLInputElement, Props>(({ onChange, id}, ref) =>
  <Button component="label">
    商品画像をアップロード
    <input
      ref={ref}
      id={id}
      type="file"
      accept="image/*"
      onChange={onChange}
      hidden
    />
  </Button>
)

export default ImageInput;